import { debounce } from 'debounce';
import { docReady } from '../utils/docReady';
import { unlockBody } from '../utils/bodyLock';
const operatingHoursDays = ['M', 'TU', 'W', 'TH', 'F', 'SA', 'SU'];
const daysLabel = {
    M: dataJs.storeLocator.monday,
    TU: dataJs.storeLocator.tuesday,
    W: dataJs.storeLocator.wednesday,
    TH: dataJs.storeLocator.thursday,
    F: dataJs.storeLocator.friday,
    SA: dataJs.storeLocator.saturday,
    SU: dataJs.storeLocator.sunday,
};
let sidePanelBar = null;
// Add div element with doctor name details
const addDoctorName = (result, address, doctorName) => {
    const doctorDiv = document.createElement('div');
    doctorDiv.className = 'stockist-doctor-name';
    doctorDiv.innerText = doctorName.trim();
    result.insertBefore(doctorDiv, address);
};
const addStoreLink = (address, linkURL) => {
    const linkElem = document.createElement('a');
    linkElem.className = 'stockist-result-store-link';
    linkElem.innerText = dataJs.storeLocator.view_details_cta;
    linkElem.href = linkURL;
    address.after(linkElem);
};
const addLinkToAddress = (address, linkURL) => {
    const linkElem = document.createElement('a');
    linkElem.className = 'stockist-result-address stockist-result-address--linked';
    linkElem.innerText = address.innerText;
    linkElem.href = linkURL;
    address.after(linkElem);
};
const setupMutationObserver = () => {
    // Only setup when Stockist has rendered the widget main element
    const targetNode = document.getElementById('stockist-widget');
    if (!targetNode) {
        setTimeout(() => {
            setupMutationObserver();
        }, 300);
    }
    else {
        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };
        // Callback function to execute when mutations are observed
        const callback = (mutationsList) => {
            // Use traditional 'for loops' for IE 11
            // eslint-disable-next-line no-restricted-syntax
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    if (mutation.addedNodes.length > 0) {
                        if ((mutation.addedNodes[0].classList && mutation.addedNodes[0].classList.contains('stockist-result')) || mutation.target.classList.contains('gm-style-iw-d')) {
                            if (sidePanelBar) {
                                sidePanelBar.unMount();
                                sidePanelBar = null;
                            }
                            resizeSidePanel();
                            if (mutation.target.classList.contains('gm-style-iw-d')) {
                                // Update google map popup div to include Doctor name.
                                updateResultsOnRender(mutation.target);
                            }
                            else {
                                // Update side panel content to include custom fields.
                                updateResultsOnRender(mutation.addedNodes[0].parentNode);
                            }
                        }
                    }
                }
            }
        };
        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }
};
const customPanelInitial = `
<div class="custom-stockist__inner">
  <span data-store-image=""></span>
  <div class="custom-stockist__info-wrapper">
    <button type="button" class="custom-stockist__close-btn">
      <svg role="presentation" width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>Cross</title>
        <line x1="1.56961" y1="1.43039" x2="41.8354" y2="41.6962" stroke="black" stroke-width="1.61111"/>
        <line y1="-0.805556" x2="56.9444" y2="-0.805556" transform="matrix(-0.707107 0.707107 0.707107 0.707107 42 2)" stroke="black" stroke-width="1.61111"/>
      </svg>
    </button>
    <span data-store-name=""></span>
    <span data-doctor=""></span>
    <span data-store-address=""></span>
    <span data-store-opening-hours=""></span>
    <span data-store-phone=""></span>
    <span data-store-email=""></span>
    <div class="custom-stockist__perks">
      <span data-store-delivery=""></span>
      <span data-store-click-collect=""></span>
    </div>
    <span data-store-link=""></span>
  </div>
</div>`;
const createCustomPanel = () => {
    const wrapper = document.querySelector('#stockist-widget');
    if (wrapper) {
        const sidePanel = document.createElement('div');
        sidePanel.classList.add('custom-stockist', 'custom-stockist-modal');
        sidePanel.innerHTML = customPanelInitial;
        wrapper.appendChild(sidePanel);
    }
};
const resetCustomPanel = () => {
    const customPanel = document.querySelector('.custom-stockist');
    customPanel.innerHTML = customPanelInitial;
    customPanel.querySelector('.custom-stockist__close-btn').addEventListener('click', () => {
        customPanel.classList.remove('custom-stockist--open');
        unlockBody();
    });
};
const resizeSidePanel = () => {
    const form = document.querySelector('.stockist-search-form');
    const sidePanel = document.querySelector('.stockist-side-panel');
    if (form && sidePanel) {
        const sidePanelPaddingTop = parseInt(window.getComputedStyle(sidePanel)['paddingTop'], 10);
        const formHeight = form.getBoundingClientRect().height + parseInt(window.getComputedStyle(form)['marginBottom'], 10);
        const headerHeight = document.querySelector('.header') ? document.querySelector('.header').getBoundingClientRect().height : 0;
        const resultsList = document.querySelector('.stockist-result-list');
        if (resultsList) {
            const spaceElements = {
                panel: `${sidePanelPaddingTop / 10}rem`,
                header: `${headerHeight / 10}rem`,
                form: `${formHeight / 10}rem`,
            };
            // Set the height based and the viewport height
            resultsList.style.height = `calc(100vh - ${spaceElements.panel} - ${spaceElements.header} - ${spaceElements.form})`;
            window.dispatchEvent(new Event('resize'));
        }
    }
    const customPanel = document.querySelector('.custom-stockist');
    if (!customPanel) {
        // Commenting out this custom functionality as part of the feedback in RS-632
        // createCustomPanel();
    }
};
const initOperatingHoursAccordion = (wrapper) => {
    const OHButton = wrapper.querySelector('.custom-stockist__operating-hours--title');
    if (OHButton) {
        OHButton.addEventListener('click', (event) => {
            const parent = event.target.parentElement;
            if (parent && parent.classList.contains('show')) {
                parent.classList.remove('show');
            }
            else {
                parent.classList.add('show');
            }
        });
    }
};
const updateSidePanel = (data) => {
    const customPanel = document.querySelector('.custom-stockist');
    if (customPanel) {
        if (Object.keys(data.operatingHours).length > 0) {
            const hoursContainer = customPanel.querySelector('[data-store-opening-hours]');
            const hoursElem = addOperatingHours(data.operatingHours).outerHTML;
            hoursContainer.outerHTML = hoursElem;
            initOperatingHoursAccordion(customPanel);
        }
        if (data.featuredImage !== '') {
            const imageContainer = customPanel.querySelector('[data-store-image]');
            const imageElem = `<div class="custom-stockist__image"><img src="${data.featuredImage}" class="custom-stockist__image--inner" alt="${data.storeName}" /></div>`;
            imageContainer.outerHTML = imageElem;
        }
        if (data.storeName !== '') {
            const nameContainer = customPanel.querySelector('[data-store-name]');
            const nameElem = `<h2 class="custom-stockist__store-name">${data.storeName}</h2>`;
            nameContainer.outerHTML = nameElem;
        }
        if (data.email !== '') {
            const emailContainer = customPanel.querySelector('[data-store-email]');
            const emailElem = `<a class="custom-stockist__email" href="mailto:${data.email}" target="_blank" aria-label="Email ${data.storeName}">${data.email}</a>`;
            emailContainer.outerHTML = emailElem;
        }
        if (data.address !== '') {
            const addressContainer = customPanel.querySelector('[data-store-address]');
            const addressElem = `<p class="custom-stockist__address">${data.address}</p>`;
            addressContainer.outerHTML = addressElem;
        }
        if (data.phone !== '') {
            const phoneContainer = customPanel.querySelector('[data-store-phone]');
            const phoneElem = `<a class="custom-stockist__phone" href="tel:${data.phone}" target="_blank" aria-label="Call ${data.storeName}">${data.phone}</a>`;
            phoneContainer.outerHTML = phoneElem;
        }
        if (data.delivery === true) {
            const deliveryContainer = customPanel.querySelector('[data-store-delivery]');
            const deliveryElem = `<p class="custom-stockist__delivery">Delivery available</p>`;
            deliveryContainer.outerHTML = deliveryElem;
        }
        if (data.clickCollect === true) {
            const clickCollectContainer = customPanel.querySelector('[data-store-click-collect]');
            const clickCollectElem = `<p class="custom-stockist__click-collect">Click and Collect available</p>`;
            clickCollectContainer.outerHTML = clickCollectElem;
        }
        if (data.flagshipURL !== '') {
            const linkContainer = customPanel.querySelector('[data-store-link]');
            const linkElem = `<a class="custom-stockist__link button" href="${data.flagshipURL}" aria-label="More info on ${data.storeName}">Visit Flagship</a>`;
            linkContainer.outerHTML = linkElem;
        }
        if (data.doctorName !== '') {
            const docContainer = customPanel.querySelector('[data-doctor]');
            const docElem = `<p class="custom-stockist__doctor">${data.doctorName}</a>`;
            docContainer.outerHTML = docElem;
        }
        customPanel.classList.add('custom-stockist--open');
    }
};
const getCustomData = (result) => {
    let extraData = {
        operatingHours: {},
        doctorName: '',
        flagshipURL: '',
        delivery: false,
        clickCollect: false,
        address: '',
        email: '',
        phone: '',
        featuredImage: '',
        storeName: '',
        directions: '',
    };
    const customFields = result.querySelectorAll('.stockist-result-custom-field');
    const operatingHours = [];
    const address = result.querySelector('.stockist-result-address');
    if (address) {
        extraData = Object.assign(Object.assign({}, extraData), { address: address.innerText });
    }
    const email = result.querySelector('.stockist-result-email');
    if (email) {
        const emailInner = email.querySelector('a');
        let emailIcon = document.querySelector('.email-icon').cloneNode(true);
        emailIcon.classList.remove('visually-hidden');
        emailInner.innerHTML = emailIcon.outerHTML;
        extraData = Object.assign(Object.assign({}, extraData), { email: email.innerText });
    }
    const name = result.querySelector('.stockist-result-name');
    if (name) {
        extraData = Object.assign(Object.assign({}, extraData), { storeName: name.innerText });
    }
    const phone = result.querySelector('.stockist-result-phone');
    if (phone) {
        const phoneInner = phone.querySelector('a');
        let phoneIcon = document.querySelector('.phone-icon').cloneNode(true);
        phoneIcon.classList.remove('visually-hidden');
        phoneInner.innerHTML = phoneIcon.outerHTML;
        extraData = Object.assign(Object.assign({}, extraData), { phone: phoneInner.innerText });
    }
    const imageWrapper = result.querySelector('.stockist-result-image');
    if (imageWrapper) {
        const featuredImage = imageWrapper.querySelector('img').src;
        extraData = Object.assign(Object.assign({}, extraData), { featuredImage });
    }
    const directionsWrapper = result.querySelector('.stockist-result-directions-link');
    if (directionsWrapper) {
        const directionsLink = directionsWrapper.querySelector('a');
        extraData = Object.assign(Object.assign({}, extraData), { directions: directionsLink.href });
    }
    [...customFields].forEach((field) => {
        const label = field.querySelector('span');
        if (label) {
            const labelText = label.innerText;
            switch (labelText) {
                case 'Operating Hours (M)':
                case 'Operating Hours (TU)':
                case 'Operating Hours (W)':
                case 'Operating Hours (TH)':
                case 'Operating Hours (F)':
                case 'Operating Hours (SA)':
                case 'Operating Hours (SU)':
                    const day = labelText.match(/\((.*?)\)/i);
                    label.remove();
                    operatingHours[day[1]] = field.innerText;
                    break;
                case 'Doctor Name':
                    label.remove();
                    extraData = Object.assign(Object.assign({}, extraData), { doctorName: field.innerText });
                    break;
                case 'Same Day Delivery Available':
                    label.remove();
                    const deliveryBoolean = field.innerText.toLowerCase().replace(/\s/g, '');
                    extraData = Object.assign(Object.assign({}, extraData), { delivery: deliveryBoolean === 'true' });
                    break;
                case 'Click + Collect Available':
                    label.remove();
                    const collectBoolean = field.innerText.toLowerCase().replace(/\s/g, '');
                    extraData = Object.assign(Object.assign({}, extraData), { clickCollect: collectBoolean === 'true' });
                    break;
                case 'Discover In-Flagship':
                    label.remove();
                    extraData = Object.assign(Object.assign({}, extraData), { flagshipURL: field.innerText });
                    break;
                default:
                    break;
            }
        }
    });
    if (Object.keys(operatingHours).length > 0) {
        extraData = Object.assign(Object.assign({}, extraData), { operatingHours });
    }
    return extraData;
};
// Everytime the locator updates the results we re-organize the data and add new required elements
const updateResultsOnRender = (container) => {
    const results = container.querySelectorAll('.stockist-result');
    [...results].forEach((result) => {
        const extraData = getCustomData(result);
        const address = result.querySelector('.stockist-result-address');
        const storename = result.querySelector('.stockist-result-name');
        if (address && extraData.doctorName) {
            addDoctorName(result, address, extraData.doctorName);
        }
        if (address && storename && extraData.flagshipURL) {
            addStoreLink(address, extraData.flagshipURL);
        }
        if (address && extraData.directions) {
            addLinkToAddress(address, extraData.directions);
        }
        // Commenting out this custom functionality as part of the feedback in RS-632
        // if (extraData.operatingHours.M) {
        //   const hours = document.createElement('div');
        //   hours.classList.add('custom-operating-hours');
        //   const hoursAccordion = addOperatingHours(extraData.operatingHours).outerHTML;
        //   hours.innerHTML = hoursAccordion;
        //   result.appendChild(hours);
        //   initOperatingHoursAccordion(result);
        // }
        // Commenting out this custom functionality as part of the feedback in RS-632
        // const dialog = document.querySelector('.gm-style-iw-t');
        // if (dialog) {
        // resetCustomPanel();
        // updateSidePanel(extraData);
        // if (window.innerWidth < 768) {
        //   lockBody();
        // }
        // }
    });
};
// Add div element with operating hours button
const addOperatingHours = (operatingHours) => {
    const operatingHoursDiv = document.createElement('div');
    operatingHoursDiv.className = 'custom-stockist__operating-hours';
    const operatingHoursButton = document.createElement('button');
    operatingHoursButton.className = 'custom-stockist__operating-hours--title button--none';
    operatingHoursButton.innerText = 'Opening Hours';
    const operatingHoursList = document.createElement('div');
    operatingHoursList.className = 'custom-stockist__operating-hours--list';
    const list = operatingHoursDays
        .filter((day) => {
        return operatingHours[day] ? true : false;
    })
        .map((day) => {
        return `<div><span>${daysLabel[day]}:</span>${operatingHours[day].trim()}</div>`;
    });
    operatingHoursList.innerHTML = list.join('');
    operatingHoursDiv.appendChild(operatingHoursButton);
    operatingHoursDiv.appendChild(operatingHoursList);
    return operatingHoursDiv;
};
// Select the node that will be observed for mutations
const initStockist = () => {
    setupMutationObserver();
};
// Initialize custom code when Stockist library is loaded
const checkIsReady = () => {
    if (typeof Stockist === 'undefined' || !Stockist.loaded) {
        setTimeout(() => {
            checkIsReady();
        }, 300);
    }
    else {
        initStockist();
    }
};
let lastWidth = 0;
docReady(() => {
    checkIsReady();
    lastWidth = window.innerWidth;
    window.addEventListener('resize', debounce(() => {
        if (lastWidth !== window.innerWidth) {
            lastWidth = window.innerWidth;
            resizeSidePanel();
        }
    }, 200));
});
